// extracted by mini-css-extract-plugin
export default {"detatils":"commonDetails_detatils__k6Ty1"};